import gql from 'graphql-tag';

export class ActionPlanFragments {
  static actionPlan = gql`
    fragment actionPlanFragment on ListActionPlansResult {
      actionPlans {
        id
        title
        description
        createdAt
        updatedAt
      }
    }
  `;
}
